<template>
  <div class="ly-flags">
    <template v-if="on">
      <!-- плашки сессий: древко на глубине своей карточки, флаг над столбцом -->
      <template v-for="p in plates" :key="'p' + p.u.id">
        <div class="ly-pole" :class="p.md" :style="p.poleStyle" data-kind="flat" :data-sz="p.sz"
             :data-story="p.i" :data-pole="p.hb">
          <i v-for="t in p.tiles" :key="t.k" class="ly-pt" :class="{ on: t.on }" :style="t.style"></i>
          <i class="ly-mast" :style="p.mastStyle"></i>
        </div>
        <div class="ly-flag" :class="{ tight: g.tight, rep: p.rep, hasw: p.words, on: p.i === selectedIndex, none: p.none }" :style="p.flagStyle"
             data-kind="flag" :data-sz="p.sz" :data-story="p.i" :data-pole="p.hb" :title="p.tip"
             @click.stop="$emit('select-unit', p.i)">
          <b>{{ p.t }}</b><s>{{ p.s }}</s>
          <i v-if="!phOff" class="ly-fedge" :style="{ background: phraseColor(p.u.phrase) }"></i>
          <span v-if="p.words" class="ly-fwords" :title="p.words.tip">
            <i v-for="m in p.words.mix" :key="m.k"><b :style="{ background: phraseColor(m.k) }"></b>{{ m.n }}</i>
          </span>
        </div>
      </template>

      <!-- строй: у каждого заголовка своё древко длиной в медианный блок оттока -->
      <template v-for="h in stroy" :key="'s' + h.key">
        <div class="ly-pole" :style="h.poleStyle" data-kind="flat" :data-sz="h.sz" data-an="stroy" :data-med="h.med">
          <i v-for="t in h.tiles" :key="t.k" class="ly-pt" :class="{ on: t.on }" :style="t.style"></i>
          <i class="ly-whisk" :style="h.whiskStyle"></i>
          <i class="ly-medtick" :style="h.tickStyle"></i>
          <i v-for="d in h.dots" :key="d.k" class="ly-gdot" :style="d.style" :title="d.tip"></i>
          <i class="ly-mast" :style="h.mastStyle"></i>
        </div>
        <div class="ly-flag an" :class="{ tight: g.tight, none: h.none }" :style="h.flagStyle"
             data-kind="flag" :data-sz="h.sz" data-an="stroy" :data-med="h.med" :title="h.tip">
          <b>{{ h.t }}</b><s>{{ h.s || '' }}</s>
          <i v-if="!phOff" class="ly-fedge"><u v-for="m in h.edge" :key="m.k" :style="m.style"></u></i>
          <em class="ly-anb">{{ h.n }}</em>
        </div>
      </template>

      <!-- коромысло: знаковое отклонение среднего блока заголовка от опоры среза -->
      <template v-for="h in koro" :key="'k' + h.key">
        <div class="ly-pole" :style="h.hostStyle" data-kind="flat2" :data-sz="h.sz" data-an="koro" :data-d="h.dTxt">
          <i class="ly-zero" :style="h.zeroStyle"></i>
          <i v-if="h.bar" class="ly-dbar" :class="h.sign" :style="h.bar"></i>
          <i class="ly-kdot" :class="h.sign" :style="h.dotStyle"></i>
          <i v-for="d in h.dots" :key="d.k" class="ly-gdot big" :style="d.style" :title="d.tip"></i>
          <i v-if="h.beam" class="ly-beam" :style="h.beam"></i>
        </div>
        <div class="ly-flag an" :class="[h.sign, { tight: g.tight, none: h.none }]" :style="h.flagStyle"
             data-kind="flag2" :data-sz="h.sz" data-an="koro" :data-d="h.dTxt" :title="h.tip">
          <b>{{ h.t }}</b><s>{{ h.s || '' }}</s>
          <i v-if="!phOff" class="ly-fedge"><u v-for="m in h.edge" :key="m.k" :style="m.style"></u></i>
          <em class="ly-anb">{{ h.label }}</em>
        </div>
      </template>
    </template>

    <!-- Легенда и решётка — плоские панели поверх сцены: камера их вращать не должна,
         поэтому уносим их из .ly-cam в .ly-stage. Пока сцены нет — рисуем на месте. -->
    <Teleport :to="stageEl" :disabled="!stageEl">
      <div v-if="legend" class="ly-anleg">
        <b>{{ legend.name }}</b>
        <span>{{ legend.sub }}</span>
        <div v-if="legend.vals.length" class="ly-al-g">
          <i v-for="v in legend.vals" :key="v.k"><b :style="{ background: v.c }"></b>{{ v.n }}</i>
        </div>
        <div class="ly-al-n">{{ legend.note }}</div>
      </div>

      <div v-if="grid" class="ly-angrid" @mousedown.stop @wheel.stop @click.stop>
        <div class="ly-ag-h">
          <b>Разбор заголовков · решётка</b>
          <span>медиана среза — блок {{ stats.M }} · сессий {{ stats.n }}</span>
          <button type="button" class="ly-ag-b" @click="anDiff = !anDiff">{{ anDiff ? 'доли' : 'разность' }}</button>
          <button v-if="grid.ref" type="button" class="ly-ag-b" @click="anRef = null; anDiff = false">снять опору</button>
        </div>
        <div class="ly-ag-r ly-ag-head">
          <i class="ly-ag-t"></i>
          <i v-for="k in g.nB" :key="k" class="ly-ag-c" :class="{ med: k === stats.M }">{{ k }}</i>
          <i class="ly-ag-m">мед</i>
        </div>
        <div v-for="r in grid.rows" :key="r.k" class="ly-ag-r" :class="{ sub: r.sub, ref: r.ref }"
             :title="r.sub ? null : r.full" @click="r.sub ? null : toggleRef(r.key)">
          <i class="ly-ag-t" :class="{ none: r.none }"><span v-if="r.sub" class="ly-ag-g" :style="{ background: r.gc }"></span>{{ r.name }}</i>
          <i v-for="c in r.cells" :key="c.k" class="ly-ag-c" :class="{ here: c.here, med: c.med }"
             :style="c.style" :title="c.tip"></i>
          <i class="ly-ag-m"><b>{{ r.med }}</b><s>{{ r.d > 0 ? '+' : '' }}{{ r.d }}</s><u>{{ r.n }}</u></i>
        </div>
        <div class="ly-ag-f">строка — заголовок, столбец — блок, клетка — доля сессий{{ anDiff ? (grid.ref ? ' относительно опорного заголовка' : ' относительно всего среза') : '' }}. Клик по строке — сделать её опорой.</div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { plural } from '@/utils/segments';
import { headOf, NO_SWAP } from '@/utils/layers';

const DEVS = ['мобильное', 'планшет', 'десктоп'];
const SES = ['сессии', 'сессий', 'сессий'];
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
// Одно округление на всё в коромысле: подпись, цвет и наличие столбика обязаны говорить
// одно и то же, иначе бывает «0,0» с красным столбиком.
const dround = v => Math.round(v * 100) / 100;
const dfmt = v => {
  const r = dround(v);
  const zn = r > 0 ? '+' : r < 0 ? '−' : '';
  // мельче десятой доли блока — сотыми, иначе «0,0» скрыло бы знак
  return zn + Math.abs(r).toFixed(Math.abs(r) < 0.05 && r !== 0 ? 2 : 1).replace('.', ',');
};
// Древко живёт в плоскости карточек (flat), полотнище — билборд (flag). Отступ колонки
// флагов задан в системе камеры переменными --fdx/--fdz (у коромысла --gdx/--gdz), их
// выставляет сцена на .ly-cam: так синяя древка стоит на глубине синей своей карточки.
// В торце (sideView) древко доворачивается тем же углом, что и карточки, иначе схлопывается в нитку.
const SIDE = side => (side ? ' rotateY(var(--by,0deg))' : '');
const TF = {
  flat: (sz, side) => `translate3d(var(--fdx,0px), 0px, calc(${sz}px + var(--fdz,0px)))${SIDE(side)}`,
  flag: sz => `translate3d(var(--fdx,0px), 0px, calc(${sz}px + var(--fdz,0px))) rotateY(var(--by,0deg)) rotateX(var(--bx,0deg))`,
  flat2: (sz, side) => `translate3d(var(--gdx,0px), 0px, calc(${sz}px + var(--gdz,0px)))${SIDE(side)}`,
  flag2: sz => `translate3d(var(--gdx,0px), 0px, calc(${sz}px + var(--gdz,0px))) rotateY(var(--by,0deg)) rotateX(var(--bx,0deg))`,
};

export default {
  name: 'LayerFlags',
  props: {
    geom: { type: Object, default: null },
    layout: { type: Object, default: null },
    storyBlock: { type: Number, default: null },
    mode: { type: Object, default: () => ({}) },      // {plates, stroy, koro, grid, attr, words}
    stats: { type: Object, default: null },           // результат headStats
    phraseColor: { type: Function, default: () => 'var(--ph0)' },
    phOff: { type: Boolean, default: false },         // «подписи: нет» — без канта, мачта серая, без слов на флаге
    // необязательное состояние сцены
    medSideOf: { type: Function, default: null },     // unit → 'lo' | 'eq' | 'hi' | null — сторона медианы
    selectedIndex: { type: Number, default: null },   // выбранная карточка — рамка у её флага
    rangeShift: { type: Number, default: 0 },         // px: слои сдвинуты за полоску «в окне» ленты
    sideView: { type: Boolean, default: false },      // вид вдоль стопки
    tileW: { type: Number, default: null },           // ширина плитки слоя (корешки — 20 px), null → ширина столбца
  },
  emits: ['select-unit'],
  data() {
    return { stageEl: null, anRef: null, anDiff: false };
  },
  computed: {
    on() {
      return this.storyBlock !== null && !!this.geom && !!this.layout
        && this.geom.rows.length > 0 && this.layout.items.length > 0;
    },
    // Геометрия флагов (прототип 4136–4177): шаг строк блоков задаёт высоту полотнища.
    g() {
      const geom = this.geom;
      if (!geom || !geom.rows.length) return { nB: 0 };
      const rows = geom.rows;
      const rowStep = rows.length > 1 ? rows[1].top - rows[0].top : 32;
      const FLAG_H = clamp(rowStep - 2, 24, 42);
      // древко той же ширины, что плитка карточки: на корешках флаг должен стоять над корешком
      const pw = this.tileW || geom.colW;
      return { LX: geom.colLeft + this.rangeShift, top: geom.colTop, pw, colH: geom.colH, rowStep, FLAG_H,
        tight: FLAG_H < 40, nB: rows.length, ox: Math.round(pw / 2) - 1 };
    },
    anScene() { return !!(this.mode.stroy || this.mode.koro); },
    plates() {
      if (!this.on || !this.mode.plates || this.anScene) return [];
      const { LX, top, pw, FLAG_H, ox } = this.g;
      // Без оттока нет высоты древка (спека). Флаг есть у каждой карточки с оттоком: без
      // заголовка полотнище говорит, почему его нет, — как «без подмены» / «нет данных» в решётке.
      const items = this.layout.items.filter(it => it.unit.churn >= 0);
      const tiers = new Map();
      items.forEach(({ unit: u }) => {
        const k = headOf(u).key;
        let e = tiers.get(k);
        if (!e) { e = { n: 0, phc: Object.create(null) }; tiers.set(k, e); }
        e.n++;
        e.phc[u.phrase] = (e.phc[u.phrase] || 0) + 1;
      });
      return items.map(it => {
        const u = it.unit;
        const h = headOf(u), e = tiers.get(h.key);
        const hb = u.churn + 1;
        const poleH = this.poleHof(hb);
        const sz = -it.z;
        const kx = it.x || 0;
        const mix = Object.keys(e.phc).map(k => ({ k, n: e.phc[k] }));
        // Древко — та же карточка сбоку: синяя красится по стороне медианы вместе с ней,
        // иначе карточка красная, а её древко синее, и связка флаг—карточка не читается.
        const side = this.medSideOf ? this.medSideOf(u) : null;
        return {
          u, i: it.i, hb, sz, rep: e.n > 1 && !h.none, md: side ? 'md-' + side : null, t: h.t, s: h.s, none: h.none,
          poleStyle: `left:${LX + kx}px; top:${top}px; width:${pw}px; height:${poleH}px;`
            + ` transform-origin:${pw / 2}px ${poleH / 2}px; transform:${TF.flat(sz, this.sideView)};`,
          tiles: this.tiles(hb, hb),
          mastStyle: `left:${ox}px; top:${-poleH}px; height:${poleH}px;` + this.mastColor(u.phrase),
          // нижний край полотнища на высоте poleH над столбцом: длина мачты = глубина оттока
          flagStyle: `left:${LX + kx}px; top:${top - poleH - FLAG_H}px; width:260px; height:${FLAG_H}px;`
            + ` transform-origin:${ox}px 100%; transform:${TF.flag(sz)};`,
          words: this.mode.words && !this.phOff ? { mix, tip: mix.map(m => `${m.k}: ${m.n}`).join(' · ') } : null,
          // служебный текст — не повтор заголовка: пунктира «такой же текст» у него нет
          tip: h.none ? (h.t === NO_SWAP ? 'Показ записан, заголовок не подменялся' : 'Показ не записан')
              + (e.n > 1 ? ` · так же ещё у ${e.n - 1} ${plural(e.n - 1, SES)}` : '')
            : e.n > 1 ? `Такой же текст ещё у ${e.n - 1} ${plural(e.n - 1, SES)}` : 'Текст встречается один раз',
        };
      });
    },
    list() { return this.on && this.stats ? this.stats.list : []; },
    // шаг по глубине между заголовками разбора
    step() {
      const NH = Math.max(1, this.list.length);
      return clamp(Math.round((this.layout.maxDepth || 600) / NH), 90, 240);
    },
    stroy() {
      if (!this.mode.stroy || !this.list.length) return [];
      const { LX, top, pw, FLAG_H, ox } = this.g;
      const st = this.stats;
      return this.list.map((h, i) => {
        const sz = -(i * this.step);
        const poleH = this.poleHof(h.med);
        // усы квартилей: без них узкий пик и размазанный хвост выглядят одинаково
        const y1 = this.midOf(h.q1), y3 = this.midOf(h.q3);
        return {
          key: h.key, t: h.t, s: h.s, none: h.none, n: h.n, med: h.med, sz,
          poleStyle: `left:${LX}px; top:${top}px; width:${pw}px; height:${poleH}px;`
            + ` transform-origin:${pw / 2}px ${poleH / 2}px; transform:${TF.flat(sz, this.sideView)};`,
          tiles: this.tiles(h.med, h.med),
          whiskStyle: `left:${pw + 5}px; top:${Math.min(y1, y3)}px; height:${Math.max(3, Math.abs(y3 - y1))}px;`,
          // метка медианы среза — общая для всех древков, от неё читается «выше/ниже»
          tickStyle: `left:-4px; top:${this.poleHof(st.M) - 1}px; width:${pw + 8}px;`,
          dots: this.mode.attr && this.mode.attr !== 'none' ? h.groups.map((gr, gi) => ({
            k: String(gr.v),
            style: `left:${pw + 13 + gi * 9}px; top:${this.midOf(gr.med) - 4}px; background:${this.groupColor(gr.v)};`,
            tip: `${this.groupName(gr.v)}: медиана блок ${gr.med}, сессий ${gr.n}`,
          })) : [],
          mastStyle: `left:${ox}px; top:${-poleH}px; height:${poleH}px;` + this.mastColor(h.ph),
          flagStyle: `left:${LX}px; top:${top - poleH - FLAG_H}px; width:260px; height:${FLAG_H}px;`
            + ` transform-origin:${ox}px 100%; transform:${TF.flag(sz)};`,
          edge: this.edge(h.mix),
          tip: `Медиана блок ${h.med} · квартили ${h.q1}–${h.q3} · сессий ${h.n}`
            + (this.attrOn ? ' · ' + h.groups.map(gr => `${this.groupName(gr.v)} ${gr.med}`).join(', ') : ''),
        };
      });
    },
    // Растягиваем так, чтобы самое большое отклонение занимало 2,5 строки блока;
    // множитель честно пишется в легенду.
    koroK() {
      const maxD = this.list.reduce((m, h) => Math.max(m, Math.abs(h.dm)), 0.02);
      return clamp(Math.round(2.5 / maxD), 1, 12);
    },
    koro() {
      if (!this.mode.koro || !this.list.length) return [];
      const { LX, top, pw, colH, FLAG_H, rowStep, ox } = this.g;
      const st = this.stats;
      const zeroY = this.poleHf(st.Mm);                 // опора — средний блок всего среза
      const K = this.koroK;
      // вверх — позже опоры, вниз — раньше; на экране y растёт вниз, поэтому минус
      const yFor = d => zeroY - d * K * rowStep;
      const cx = Math.round(pw / 2);
      return this.list.map((h, i) => {
        const sz = -(i * this.step);
        const d2 = dround(h.dm);
        const yh = yFor(h.dm);
        const len = Math.abs(yh - zeroY);
        const sign = d2 > 0 ? 'late' : d2 < 0 ? 'early' : 'zero';
        let dots = [], beam = null;
        if (this.attrOn && h.groups.length > 1) {
          const k = h.groups.length;
          const ys = h.groups.map(gr => yFor(gr.dm));
          dots = h.groups.map((gr, gi) => ({
            k: String(gr.v),
            style: `left:${cx - (k - 1) * 7 + gi * 14 - 5}px; top:${ys[gi] - 5}px; background:${this.groupColor(gr.v)};`,
            tip: `${this.groupName(gr.v)}: ${dfmt(gr.dm)} блока от опоры, сессий ${gr.n}`,
          }));
          // соединяем крайние точки: наклон и есть влияние признака
          const x0 = cx - (k - 1) * 7, x1 = x0 + (k - 1) * 14, dy = ys[k - 1] - ys[0];
          const L = Math.sqrt((x1 - x0) * (x1 - x0) + dy * dy);
          const ang = Math.atan2(dy, x1 - x0) * 180 / Math.PI;
          beam = `left:${x0}px; top:${ys[0]}px; width:${L}px; transform:rotate(${ang.toFixed(2)}deg); transform-origin:0 50%;`;
        }
        return {
          key: h.key, t: h.t, s: h.s, none: h.none, sz, sign, dTxt: d2.toFixed(2), label: dfmt(h.dm),
          // хост во весь столбец: опора бывает и выше, и ниже середины
          hostStyle: `left:${LX}px; top:${top}px; width:${pw}px; height:${colH}px;`
            + ` transform-origin:${pw / 2}px ${colH / 2}px; transform:${TF.flat2(sz, this.sideView)};`,
          zeroStyle: `left:-10px; top:${zeroY - 1}px; width:${pw + 20}px;`,
          // столбик есть ровно тогда, когда округлённое отклонение не ноль
          bar: d2 !== 0 ? `left:${cx - 4}px; top:${Math.min(yh, zeroY)}px; height:${Math.max(1, len)}px;` : null,
          // метка есть всегда: иначе «ровно на опоре» и «заголовка нет» выглядят одинаково
          dotStyle: `left:${cx - 6}px; top:${yh - 6}px;`,
          dots, beam,
          flagStyle: `left:${LX}px; top:${top + yh - FLAG_H - 8}px; width:260px; height:${FLAG_H}px;`
            + ` transform-origin:${ox}px 100%; transform:${TF.flag2(sz)};`,
          edge: this.edge(h.mix),
          tip: `Средний блок ${h.mean.toFixed(2)} при опоре среза ${st.Mm.toFixed(2)}`
            + ` — отклонение ${dfmt(h.dm)} блока · медиана блок ${h.med} · сессий ${h.n}`
            + (this.attrOn ? ' · размах по признаку ' + h.span : ''),
        };
      });
    },
    attrOn() { return !!this.mode.attr && this.mode.attr !== 'none'; },
    // Легенда разреза (5800–5822): без неё цветные точки на древках — просто точки.
    legend() {
      if (!this.anScene || !this.list.length) return null;
      const st = this.stats, { stroy, koro } = this.mode;
      const K = this.koroK;
      const vals = new Map();
      if (this.attrOn) st.list.forEach(h => h.groups.forEach(gr => vals.set(gr.v, gr.v)));
      const cmp = (a, b) => (typeof a === 'number' ? a - b : String(a).localeCompare(String(b), 'ru'));
      return {
        name: stroy && koro ? 'строй и коромысло' : stroy ? 'строй' : 'коромысло',
        sub: `заголовков ${st.list.filter(h => !h.none).length}, сессий ${st.n}`
          + (stroy ? ` · медиана среза — блок ${st.M}` : '')
          + (koro ? ` · опора коромысла — средний блок ${st.Mm.toFixed(2).replace('.', ',')}` : ''),
        vals: [...vals.keys()].sort(cmp).map(v => ({ k: String(v), c: this.groupColor(v), n: this.groupName(v) })),
        note: (stroy ? 'длина древка — медианный блок оттока · усы — квартили' : '')
          + (koro ? (stroy ? ' · ' : '') + 'коромысло: отклонение среднего блока от опоры, вверх красным «позже», вниз синим «раньше»'
            + (K > 1 ? ` · шкала растянута ×${K}: одна строка блока = ${(1 / K).toFixed(2).replace('.', ',')} блока` : '') : ''),
      };
    },
    // Решётка «заголовок × блок» (5824–5883): клетка — доля сессий заголовка с оттоком в блоке.
    grid() {
      if (!this.mode.grid || !this.on || !this.stats) return null;
      const st = this.stats;
      const ref = this.anRef !== null ? st.list.find(h => h.key === this.anRef) : null;
      const base = ref ? ref.hist : st.hist;
      const diff = this.anDiff;
      const cellStyle = (v, dv) => {
        if (!diff) return `background:color-mix(in srgb, var(--accent) ${((0.06 + v * 0.9) * 100).toFixed(1)}%, transparent);`;
        const a = Math.min(1, Math.abs(dv) * 2.2);
        return `background:color-mix(in srgb, var(${dv >= 0 ? '--div-pos' : '--div-neg'}) ${((0.06 + a * 0.85) * 100).toFixed(1)}%, transparent);`;
      };
      const row = (h, gr) => {
        const hist = gr ? gr.hist : h.hist;
        const med = gr ? gr.med : h.med;
        return {
          k: h.key + (gr ? '\u0001' + gr.v : ''), key: h.key, sub: !!gr, ref: !gr && this.anRef === h.key, none: !gr && h.none,
          name: gr ? this.groupName(gr.v) : h.t, gc: gr ? this.groupColor(gr.v) : null,
          full: h.t + (h.s ? ' — ' + h.s : ''),
          med, d: gr ? gr.d : h.d, n: gr ? gr.n : h.n,
          cells: hist.map((v, k) => {
            const dv = v - (base[k] || 0);
            return { k, here: k + 1 === med, med: k + 1 === st.M, style: cellStyle(v, dv),
              tip: `блок ${k + 1}: ${Math.round(v * 100)} %`
                + (diff ? ` (${dv >= 0 ? '+' : ''}${Math.round(dv * 100)} п.п.)` : '') };
          }),
        };
      };
      const rows = [];
      st.list.forEach(h => {
        rows.push(row(h));
        if (this.attrOn) h.groups.forEach(gr => rows.push(row(h, gr)));
      });
      return { ref, rows };
    },
  },
  watch: {
    'mode.grid'(v) { if (!v) { this.anRef = null; this.anDiff = false; } },
    // опорный заголовок пропал из данных — снимаем опору, иначе состояние висит невидимым
    stats(st) {
      if (this.anRef !== null && !(st && st.list.some(h => h.key === this.anRef))) { this.anRef = null; this.anDiff = false; }
    },
  },
  mounted() {
    this.stageEl = this.$el.closest('.ly-stage');
  },
  methods: {
    // мачта цвета фразы; при «подписи: нет» — серая (цвет из .ly-mast)
    mastColor(ph) { return this.phOff ? '' : ` background:${this.phraseColor(ph)}; opacity:.5;`; },
    rowOf(b) { const r = this.geom.rows; return r[clamp(Math.min(r.length, b) - 1, 0, r.length - 1)]; },
    // нижний край блока b (1..N) от верха столбца — высота древка
    poleHof(b) { const r = this.rowOf(b); return r.top + r.h - this.geom.colTop; },
    midOf(b) { const r = this.rowOf(b); return r.top + r.h / 2 - this.geom.colTop; },
    // для дробного номера блока — линейно между нижними краями соседних строк (коромысло)
    poleHf(x) {
      const n = this.geom.rows.length;
      const lo = clamp(Math.floor(x), 1, n), hi = clamp(lo + 1, 1, n);
      const a = this.poleHof(lo), b = this.poleHof(hi);
      return a + (b - a) * clamp(x - lo, 0, 1);
    },
    // плитки древка до блока upTo включительно, синяя — в блоке onB
    tiles(upTo, onB) {
      const { pw, top } = this.g;
      return this.geom.rows.slice(0, upTo).map((r, k) => ({
        k, on: k + 1 === onB, style: `left:0; top:${r.top - top}px; width:${pw}px; height:${r.h}px;`,
      }));
    },
    // у сводного флага кант составной — в долях реально встретившихся фраз
    edge(mix) {
      const tot = mix.reduce((a, m) => a + m.n, 0) || 1;
      return mix.map(m => ({ k: m.k, style: `width:${(m.n / tot * 100).toFixed(2)}%; background:${this.phraseColor(m.k)};` }));
    },
    groupName(v) { return this.mode.attr === 'dev' ? (DEVS[v] || '—') : this.mode.attr === 'phrase' ? v : 'все'; },
    groupColor(v) {
      return this.mode.attr === 'dev' ? `var(--dv${v})` : this.mode.attr === 'phrase' ? this.phraseColor(v) : 'var(--text-muted)';
    },
    toggleRef(key) {
      this.anRef = this.anRef === key ? null : key;
      if (this.anRef !== null) this.anDiff = true;
    },
  },
};
</script>

<style scoped>
.ly-flags { position: absolute; left: 0; top: 0; width: 0; height: 0; transform-style: preserve-3d; }
/* Полотнище непрозрачное и того же тона, что сцена: ближняя плашка честно перекрывает дальнюю */
.ly-flag { position: absolute; box-sizing: border-box; pointer-events: auto; cursor: pointer;
  background: var(--page); border: 1px solid var(--border); border-radius: 10px; padding: 4px 9px;
  box-shadow: 0 4px 14px var(--shadow-xs); }
.ly-flag.rep { border-style: dashed; }
.ly-flag.none b { color: var(--text-muted); font-weight: 400; }
.ly-flag.an { cursor: default; }
.ly-flag b { display: block; font-size: 11.5px; font-weight: 650; color: var(--text-primary);
  line-height: 1.25; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ly-flag s { display: block; text-decoration: none; margin-top: 1px; font-size: 10px; font-weight: 400;
  color: var(--text-muted); line-height: 1.25; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ly-flag.tight { padding: 1px 8px 2px; }
.ly-flag.tight b { font-size: 11px; line-height: 1.15; }
.ly-flag.tight s { font-size: 9.5px; line-height: 1.1; margin-top: 0; }
.ly-flag.hasw b, .ly-flag.hasw s { padding-right: 70px; }
.ly-fedge { position: absolute; left: 0; right: 0; top: -6px; height: 3px; border-radius: 2px;
  opacity: .95; display: flex; overflow: hidden; }
.ly-fedge u { display: block; height: 100%; text-decoration: none; }
.ly-fwords { position: absolute; right: 6px; top: 50%; transform: translateY(-50%);
  display: flex; align-items: center; gap: 5px; }
.ly-fwords i { display: flex; align-items: center; gap: 2px; font-style: normal; font-size: 9px;
  color: var(--text-secondary); font-variant-numeric: tabular-nums; }
.ly-fwords i b { width: 6px; height: 6px; border-radius: 999px; padding: 0; }
.ly-anb { position: absolute; right: 6px; top: 50%; transform: translateY(-50%); font-size: 10px;
  font-weight: 700; color: var(--text-secondary); background: var(--surface-1); border: 1px solid var(--border);
  border-radius: 999px; padding: 0 6px; line-height: 15px; font-style: normal; }
.ly-flag.late .ly-anb { color: var(--div-pos); border-color: var(--div-pos); }
.ly-flag.early .ly-anb { color: var(--div-neg); border-color: var(--div-neg); }

/* Древко — те же плитки, что на карточке, но ряд обрывается на блоке оттока */
.ly-pole { position: absolute; pointer-events: none; }
.ly-pt { position: absolute; border-radius: 5px; box-shadow: inset 0 0 0 1px var(--border); }
.ly-pt.on { background: var(--accent); box-shadow: inset 0 0 0 1px var(--shadow-xs), 0 1px 4px var(--shadow-sm); }
.ly-pole.md-lo .ly-pt.on { background: var(--cell-100); }
.ly-pole.md-hi .ly-pt.on { background: var(--ev-goal); }
.ly-flag.on { border-color: var(--accent); box-shadow: 0 8px 22px var(--shadow-sm); }
.ly-mast { position: absolute; width: 2px; border-radius: 1px; background: var(--grid); }
.ly-whisk { position: absolute; width: 2px; border-radius: 1px; background: var(--text-muted); opacity: .55; }
.ly-medtick { position: absolute; height: 0; border-top: 1px dashed var(--text-primary); opacity: .55; }
.ly-gdot { position: absolute; width: 8px; height: 8px; border-radius: 999px; box-shadow: 0 0 0 1.5px var(--page); }
.ly-gdot.big { width: 10px; height: 10px; }
.ly-zero { position: absolute; height: 0; border-top: 1px dashed var(--text-primary); opacity: .7; }
.ly-dbar { position: absolute; width: 8px; border-radius: 3px; }
.ly-dbar.late { background: var(--div-pos); }
.ly-dbar.early { background: var(--div-neg); }
/* отклонение в пределах округления — серое, «практически на опоре» */
.ly-dbar.zero { background: var(--text-muted); opacity: .5; }
.ly-kdot { position: absolute; width: 12px; height: 12px; border-radius: 999px; box-sizing: border-box;
  box-shadow: 0 0 0 2px var(--page); background: var(--text-muted); }
.ly-kdot.late { background: var(--div-pos); }
.ly-kdot.early { background: var(--div-neg); }
.ly-kdot.zero { background: var(--surface-1); border: 2.5px solid var(--text-secondary); }
.ly-beam { position: absolute; height: 2px; border-radius: 1px; background: var(--text-secondary); opacity: .55; }

.ly-anleg { position: absolute; left: 14px; bottom: 14px; z-index: 7; max-width: 330px;
  background: var(--surface-1); border: 1px solid var(--border); border-radius: 10px;
  padding: 7px 10px 8px; box-shadow: 0 10px 28px var(--shadow-xs); pointer-events: none; }
.ly-anleg > b { font-size: 11.5px; font-weight: 650; display: block; }
.ly-anleg > span { font-size: 10px; color: var(--text-muted); }
.ly-al-g { display: flex; flex-wrap: wrap; gap: 4px 12px; margin-top: 5px; }
.ly-al-g i { font-style: normal; font-size: 10.5px; color: var(--text-secondary); display: flex; align-items: center; gap: 5px; }
.ly-al-g i b { width: 8px; height: 8px; border-radius: 999px; display: block; }
.ly-al-n { margin-top: 5px; font-size: 9.5px; color: var(--text-muted); line-height: 1.35; }

.ly-angrid { position: absolute; left: 14px; top: 14px; z-index: 7; width: 466px; max-height: calc(100% - 28px);
  overflow: auto; background: var(--surface-1); border: 1px solid var(--border); border-radius: 12px;
  padding: 9px 10px 8px; box-shadow: 0 14px 40px var(--shadow-xs); pointer-events: auto; }
.ly-ag-h { display: flex; align-items: center; gap: 8px; margin-bottom: 7px; flex-wrap: wrap; }
.ly-ag-h b { font-size: 12px; font-weight: 650; }
.ly-ag-h span { font-size: 10.5px; color: var(--text-muted); }
.ly-ag-b { margin-left: auto; font: inherit; font-size: 10.5px; cursor: pointer; background: var(--page);
  border: 1px solid var(--border); border-radius: 999px; padding: 2px 9px; color: var(--text-secondary); }
.ly-ag-b + .ly-ag-b { margin-left: 0; }
.ly-ag-b:hover { color: var(--text-primary); border-color: var(--text-muted); }
.ly-ag-r { display: flex; align-items: center; gap: 2px; border-radius: 5px; padding: 1px 2px; cursor: pointer; }
.ly-ag-r:hover { background: var(--page); }
.ly-ag-r.ref { box-shadow: inset 0 0 0 1.5px var(--accent); }
.ly-ag-r.sub { cursor: default; opacity: .9; }
.ly-ag-head { cursor: default; color: var(--text-muted); font-size: 9.5px; }
.ly-ag-t { flex: 0 0 172px; font-size: 10.5px; font-style: normal; white-space: nowrap; overflow: hidden;
  text-overflow: ellipsis; display: flex; align-items: center; gap: 5px; }
.ly-ag-r.sub .ly-ag-t { padding-left: 12px; color: var(--text-secondary); font-size: 10px; }
.ly-ag-t.none { color: var(--text-muted); }
.ly-ag-g { width: 7px; height: 7px; border-radius: 999px; flex: 0 0 auto; }
.ly-ag-c { flex: 1 1 0; height: 16px; border-radius: 3px; font-style: normal; text-align: center;
  line-height: 16px; box-shadow: inset 0 0 0 1px var(--border); }
.ly-ag-head .ly-ag-c { box-shadow: none; }
.ly-ag-c.med { box-shadow: inset 0 0 0 1px var(--border), inset 2px 0 0 var(--text-muted); }
.ly-ag-c.here { box-shadow: inset 0 0 0 2px var(--text-primary); }
.ly-ag-m { flex: 0 0 62px; font-style: normal; display: flex; align-items: center; gap: 4px;
  justify-content: flex-end; font-size: 10px; }
.ly-ag-m b { font-size: 11px; font-weight: 700; }
.ly-ag-m s, .ly-ag-m u { text-decoration: none; color: var(--text-muted); }
.ly-ag-m u { opacity: .75; }
.ly-ag-f { margin-top: 6px; font-size: 9.5px; color: var(--text-muted); line-height: 1.35; }
</style>
